import React from 'react';

import {
  expandSidebarAssetsList as expand,
  collapseSidebarAssetsList as collapse
} from 'RLX/State/Ui/Sidebar/SidebarActions';

function AssetsMenu ({ ui } = {}) {

  const collapsed = ui.sidebar.assetsListCollapsed;

  const assetLinks = collapsed ? [] : [
    {
      text: 'Show All',
      icon: 'archive',
      url: '/RLX/dash/assets'
    }
  ];

  return [
    {
      text: 'ASSETS',
      className: 'heading' + (collapsed ? ' collapsed' : ''),
      onClick: collapsed ? expand : collapse,
      icon: collapsed ? 'caret-left' : 'caret-down'
    },
    ...assetLinks
  ]
};

export default AssetsMenu;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Config/Menus/AssetsMenu.jsx